import { Box, Chip, Divider, Grid2, Stack, Typography } from "@mui/material";
import React from "react";
import CommonButton from "../../../../component/Button";
import FileUpload from "../../../matches/quick-match/components/FileUpload";
import { CustomizeSpan } from "../../../jobs/style";

function UploadCandidateResume({
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handleFileUpload,
  isDragging,
  files,
  handleDeleteFile,
  handleNextUploadClick,
  isLoading,
}) {
  return (
    <Box width={"600px"} margin={"auto"}>
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Typography fontWeight={600} fontSize={20}>
            {"Upload Resume"}
          </Typography>
        </Grid2>

        <Grid2 size={12}>
            <Box sx={{ mb: 3 }}>
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 1 }}>
              <Typography fontSize="13px" fontWeight={600} color="#101828">
                Resume
              </Typography>
              <Typography fontSize="13px" fontWeight={400} color="#667085">
                (Please upload a clear and readable resume file only)
              </Typography>
              <Typography fontSize="13px" fontWeight={600} color="#F04438">
                *
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              gap={0.75}
              sx={{
                px: 1.5,
                py: 1,
                bgcolor: "#F9FAFB",
                border: "1px solid #EAECF0",
                borderRadius: "8px",
                width: "fit-content",
              }}
            >
              <Typography fontSize="11.5px" fontWeight={500} color="#667085">
                Supported formats:
              </Typography>
              {["PDF", "DOC", "DOCX"].map((fmt) => (
                <Chip
                  key={fmt}
                  label={fmt}
                  size="small"
                  sx={{
                    height: "22px",
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#6941C6",
                    bgcolor: "#F4EBFF",
                    border: "1px solid #E9D7FE",
                    borderRadius: "6px",
                    "& .MuiChip-label": { px: "8px" },
                  }}
                />
              ))}
              <Divider orientation="vertical" flexItem sx={{ mx: 0.5, borderColor: "#EAECF0" }} />
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography fontSize="11.5px" fontWeight={500} color="#667085">
                  Max size:
                </Typography>
                <Typography
                  fontSize="11.5px"
                  fontWeight={700}
                  color="#344054"
                  sx={{
                    px: 0.75,
                    py: 0.1,
                    bgcolor: "#F2F4F7",
                    borderRadius: "4px",
                    border: "1px solid #D0D5DD",
                  }}
                >
                  5 MB
                </Typography>
              </Stack>
            </Stack>
          </Box>

          <FileUpload
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onChange={handleFileUpload}
            isDragging={isDragging}
            files={files}
            handleDeleteFile={handleDeleteFile}
            disabled={isLoading}
          />
          <CommonButton
            width="100%"
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="600"
            value="Generate Candidate Profile"
            padding="10px 0px"
            onClick={handleNextUploadClick}
            disabled={isLoading || files.length === 0}
            loading={isLoading}
            sx={{ mt: 2 }}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
}

export default UploadCandidateResume;
